module.exports = __webpack_public_path__ + "static/media/ability.ff80a382.svg";